import { render, staticRenderFns } from "./SigConfirmAct.vue?vue&type=template&id=ad1ad37c&"
import script from "./SigConfirmAct.vue?vue&type=script&lang=js&"
export * from "./SigConfirmAct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports